<template>
  <page :breadcrumb="breadcrumb" :load="doInit">
    <!-- <template slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn text color="secondary" v-on="on">
            More Links...
            <v-icon right>mdi-link</v-icon>
          </v-btn>
          <side-function-menu :items="sideFunction" @doClick="sideMenuClick"></side-function-menu>
        </v-menu>
      </div>
    </template> -->
    <v-card>
      <!-- <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newClause">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newClause">New Clause</v-toolbar-title>
          <v-toolbar-title v-else>Edit Clause - {{this.clseNo}}</v-toolbar-title>
        </v-toolbar> -->
      <transition name="slide-x-transition" mode="out-in">
        <router-view :routerKey="routerKey"></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
// import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      breadcrumb: [],
      sideMenu: [{ name: 'reviewClause', text: 'Details', icon: 'mdi-account' }],
      sideFunction: [{ text: 'Details', icon: 'mdi-account', iconColor: 'primary', params: { key: 'reviewClause' } }],
      routerKey: undefined,
      newClause: false
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    title() {
      if (this.newClause) {
        return 'New Clause'
      } else {
        return 'Review Clause'
      }
    }
  },
  methods: {
    async doInit() {
      if (this.clseNo === 'new') {
        // do yourself
        this.newClause = true
        this.routerKey = 'reviewClause'
      } else {
        this.routerKey = 'reviewClause'
        this.sideFunction.push({
          text: 'Permitted on Policy Type',
          icon: 'mdi-folder-account',
          iconColor: 'primary',
          params: { key: 'polTypeClauseMenu', params: { clseNo: this.clseNo, clseTitle: this.clseTitle } }
        })
        this.sideFunction.push({
          text: 'Permitted on Business Class',
          icon: 'mdi-folder-account',
          iconColor: 'primary',
          params: { key: 'busClsClauseMenu', params: { clseNo: this.clseNo, clseTitle: this.clseTitle } }
        })
      }
      this.breadcrumb = this.derieveBreadcrumbByName('clause')
      // this.breadcrumb.push({
      //   name: 'reviewClause',
      //   text: this.title
      // })
    },
    sideMenuClick(data) {
      this.$router.push({ name: data.key, params: data.params })
    }
  },
  props: ['clseNo', 'clseTitle'],
  // components: {
  //   SideFunctionMenu
  // },
  mixins: [routeMixin]
}
</script>

<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
